module.exports = __webpack_public_path__ + "img/case-bj55.4b92de4e.png";